// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/vapor/_Checkbox.scss
// module id = 362
// module chunks = 83 84